webpackJsonp([273950069227526],{

/***/ 487:
/***/ (function(module, exports) {

	module.exports = {"data":{"enteringCarnegieImage":{"sizes":{"aspectRatio":1.5,"src":"/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-36c73.jpg","srcSet":"/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-8dbfc.jpg 500w,\n/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-eed4f.jpg 1000w,\n/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-36c73.jpg 1500w","sizes":"(max-width: 1500px) 100vw, 1500px"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-94a43eade14ecd1ba3eb.js